import * as React from 'react'
import { createContainer } from 'unstated-next'

export type NumberOfColumns = 1 | 2

function useColumnLayoutService(initialNumberOfColumnsOnMobile: NumberOfColumns = 2) {
  const [numberOfColumnsOnMobile, setNumberOfColumnsOnMobile] = React.useState<NumberOfColumns>(
    initialNumberOfColumnsOnMobile
  )

  return {
    numberOfColumnsOnMobile,
    setNumberOfColumnsOnMobile,
    numberOfColumnsOnDesktop: 4,
  }
}

export const ColumnLayoutService = createContainer(useColumnLayoutService)
